import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {
  SHOW_LOGO_MARKETING_EN_MOVIMIENTO_URL,
  SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL,
} from '../data/assets';

const Values = () => {
  const theme = useTheme();

  const values = [
    {
      title: 'Transmisión en Vivo',
      subtitle: 'Martes 11:00 AM por TNO Network. Conversación en tiempo real con expertas y casos de negocio.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      ),
    },
    {
      title: 'Doble liderazgo editorial',
      subtitle: 'Loyola Rosales (estrategia y negocios) y Luzmey Hernández (marketing digital) ofrecen credibilidad B2B y enfoque práctico.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
    },
    {
      title: 'Impacto Multiplataforma',
      subtitle: 'Presencia en Web, App, On-Demand y redes del ecosistema TNO. Contenido permanente para SEO y remarketing.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      ),
    },
    {
      title: 'UGC y Prueba Social',
      subtitle: 'Contenido auténtico que posiciona tu marca como recomendación de un aliado experto, no como interrupción publicitaria.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color={'primary'}
          align={'center'}
        >
          Ventajas Competitivas
        </Typography>
        <Box
          component={Typography}
          sx={{ fontWeight: 700 }}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={'primary'}
        >
          ¿Por qué Marketing en Movimiento?
        </Box>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box maxWidth={500} width={'100%'} margin="0 auto" position="relative">
            <Box
              component="img"
              src={SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL}
              alt="Marketing en Movimiento"
              sx={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                opacity: 0.4,
              }}
            />
            <Box
              component="img"
              src={SHOW_LOGO_MARKETING_EN_MOVIMIENTO_URL}
              alt="Logo Marketing en Movimiento"
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: '45%',
                height: 'auto',
                objectFit: 'contain',
                pointerEvents: 'none',
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          {values.map((item, index) => (
            <Box
              key={index}
              display="flex"
              alignItems="flex-start"
              marginBottom={4}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  bgcolor: `${theme.palette.primary.light}22`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: theme.palette.primary.main,
                  marginRight: 2,
                  flexShrink: 0,
                }}
              >
                {item.icon}
              </Box>
              <Box>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary">
                  {item.subtitle}
                </Typography>
              </Box>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Values;
